<template>
    <div class="enroll_success_box" v-loading="loading">
        <el-dialog title="注册成功" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
               <div class="images">
                    <img src="@/assets/img/login/success.png" alt="">
               </div>
               <div class="texts">注册成功</div>
                <div class="btn_flex">
                    <div class="bnts1" @click="handle_hf">返回首页</div>
                    <div class="bnts2" @click="handle_dl">去登录</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            dialogVisible:false,//显示隐藏
            
           
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {

    },
    methods: {
        handleClose(){
            this.dialogVisible=false
        },
        
        handle_open(){
            this.dialogVisible=true
        },
        handle_hf(){
            this.$router.push({
                path:'/home'
            })
        },
        handle_dl(){
            this.$router.push({
                path:'/login'
            })
        }


    },

}
</script>
<style scoped lang="less">
.enroll_success_box {
    /deep/.el-dialog__wrapper{
        .el-dialog{
            width: 580px;
            .el-dialog__header{
                background: #F7F7F7;
            }
            .el-dialog__body{
                .dialog_box{
                     .images{
                        text-align: center;
                        img{
                            width: 71px;
                            height: 71px;
                        }
                     }
                     .texts{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 18px;
                        color: #999999;
                        padding-top: 20px;
                        text-align: center; 
                     }
                    
                    .btn_flex{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 67px;

                        .bnts1{
                            width: 128px;
                            height: 40px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;

                        }
                        .bnts2{
                            width: 128px;
                            height: 40px;
                            background: #377CFD;
                            text-align: center;
                            line-height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-left:20px ;
                        }
                    }
                }
            }
        }
    }
}
</style>